@if (mission) {
  <div class="options">
    <div>
      <button class="icon"><img src="assets/images/back-icon.svg" (click)="backToMissionConfig()"/></button>
    </div>
    <div>
      <button class="icon"><img [src]="getTeamStatusIcon()" (click)="toggleTeamStatus()"/></button>
    </div>
    <div>
      @if (!isTeamComplete()) {
        <button class="icon"><img src="assets/images/add-button.svg" (click)="openTeamModal()"/></button>
      }
    </div>
  </div>
}

@if (show) {
  <table>
    <tr class="header">
      <th>{{ 'TEAM.MISSION_LEADER' | translate }}</th>
      <th>{{ 'TEAM.IN_TRAINING' | translate }}</th>
      <th>{{ 'TEAM.TEAM_MEMBER' | translate }}</th>
      <th>{{ 'TEAM.EXTERNAL' | translate }}</th>
      <th>{{ 'TEAM.LOCATION' | translate }}</th>
      <th>{{ 'TEAM.DEVICE' | translate }}</th>
      <th>{{ 'TEAM.LAST_UPDATE' | translate }}</th>
      <th></th>
    </tr>
    @for (team of missionTeams; track team) {
      <tr>
        <td>
          <input type="checkbox" class="round"
            [checked]="team.isMissionLeader"
            (change)="toggleMissionLeader(team)"
            [disabled]="isTeamComplete()"/>
        </td>
        <td>
          <input type="checkbox" class="round"
            [checked]="team.isMissionApprentice"
            (change)="toggleMissionApprentice(team)"
            [disabled]="isTeamComplete()"/>
        </td>
        <td>{{ team.teamMemberFirstName }} {{ team.teamMemberName }}</td>
        <td>
          @if (team.teamMemberId?.toUpperCase().startsWith('EXT')) {
            <span class="badge-external">
              External
            </span>
          }
        </td>
        <td>{{ team.peoplelocationname }}</td>
        <td>
          <select (change)="setMobileDevice($event, team)" [disabled]="isTeamComplete()">
            <option value="null" [selected]="team.mobileDevicepk === null"></option>
            @for (mobileDevice of mobileDevices; track mobileDevice) {
              <option
                [value]="mobileDevice.mobileDevicepk"
                [selected]="mobileDevice.mobileDevicepk === team.mobileDevicepk">
                {{ mobileDevice.mobileDeviceModelSupplier }} / {{ mobileDevice.mobileDeviceName }}
              </option>
            }
          </select>
        </td>
        <td>{{ team.lastUpdatedOn | timestampToDate | async }} {{ team.lastUpdatedBy }}</td>
        <td>
          @if (!isTeamComplete()) {
            <img
              src="assets/images/trash-icon.svg"
              (click)="removeTeam(team)"/>
          }
        </td>
      </tr>
    }
  </table>
}

@if (addingTeam) {
  <app-add-team
    [missionTeams]="missionTeams"
    [rolename]="rolename"
    [defaultMarket]="mission.marketname"
    (closeModal)="closeTeamModal($event)"
    (addTeam)="addTeam($event)">
  </app-add-team>
}